import { CSSProperties, PropsWithChildren } from 'react'
import './Alert.css'
import clsx from 'clsx'

export interface AlertProps extends PropsWithChildren {
    variant?: 'info' | 'plain' | 'success' | 'error' | 'warn'
    title: React.ReactNode
    body?: React.ReactNode
    actions?: React.ReactNode
    style?: CSSProperties
    size?: 'small' | 'regular'
}

export default function Alert(props: AlertProps) {
    const HeaderType = `h${props.size === 'small' ? 5 : 4}` as keyof JSX.IntrinsicElements
    return (
        <div className={clsx('ui-alert', props.variant ?? 'info', props.size)} style={props.style}>
            <HeaderType>{props.title}</HeaderType>
            <p className="alert-body">{props.body ?? props.children}</p>
            {props.actions && <div className="alert-actions">{props.actions}</div>}
        </div>
    )
}
